import React, { RefObject } from 'react'
import { AlignType } from '../../../types/styleTypes'
import RawHtmlUi from './ui/RawHtmlUi'

interface CommonRawHtmlInterfaceProps {
  textAlign: AlignType
  mobileTextAlign?: AlignType
  html?: string
  htmlAttrId: string
  publisherRef?: RefObject<HTMLDivElement>
}

const RawHtml = ({
  html,
  htmlAttrId,
  textAlign,
  mobileTextAlign,
  publisherRef,
}: CommonRawHtmlInterfaceProps) => {
  return (
    <RawHtmlUi
      textAlign={textAlign}
      mobileTextAlign={mobileTextAlign}
      attrId={htmlAttrId}
      dangerouslySetInnerHTML={{ __html: html ?? '' }}
      ref={publisherRef}
    />
  )
}

export default RawHtml
